import { SwaggerlessContext } from 'Context/SwaggerlessContext';
import React, { Component } from 'react';
import { NotificationManager } from 'react-notifications';
import PropTypes from 'prop-types';
import { withHousehold } from 'Context/HouseholdContext';
import Button from 'Components/ComponentLibrary/ExternalLibraries/Libraries/MaterialV4/Button';
import HeaderFooterModal from 'Components/UI/HeaderFooterModal/HeaderFooterModal';
import Input from 'Components/UI/BehavioralFormElement/Text/ExpandingTextarea';
import { noop } from 'Helpers/PropTypes';
import withEventTrackingLogEvent from 'EventTracking/withEventTrackingLogEvent';

const formTypesMap = () => ({
  recommendation: {
    header: 'Recommendation',
  },
  strategy: {
    header: 'Strategy',
  },
  footnote: {
    header: 'Footnote',
  },
});

class AddNoteModal extends Component {
  constructor(props) {
    super(props);

    this.state = {
      content: props.content,
    };

    this.onChange = this.onChange.bind(this);
    this.handleSave = this.handleSave.bind(this);
    this.closeIfOpen = this.closeIfOpen.bind(this);
    this.onSaveFinish = this.onSaveFinish.bind(this);
    this.onCtrlEnter = this.onCtrlEnter.bind(this);
  }

  componentDidUpdate(prevProps) {
    this.resetContent(prevProps);
  }

  onChange(key, val) {
    this.setState({ content: val });
  }

  onCtrlEnter() {
    this.handleSave();
  }

  onSaveFinish() {
    const { isOpen, onClose, type } = this.props;
    const types = formTypesMap();
    if (isOpen) {
      onClose();
    }
    NotificationManager.success(`${types[type].header} saved.`);
  }

  resetContent(prevProps) {
    const { isOpen, content } = this.props;
    const { isOpen: wasOpen } = prevProps;
    if (!isOpen && wasOpen) {
      this.setState({ content });
    }
  }

  closeIfOpen() {
    const { isOpen, onClose } = this.props;
    if (isOpen) {
      onClose();
    }
  }

  handleSave() {
    const { content } = this.state;
    if (content === '') {
      return;
    }
    const {
      householdId, // eslint-disable-line react/prop-types
      sectionId, // eslint-disable-line react/prop-types
      type,
      maxWeightFunc,
      onDataUpdate,
      EventTracking, // eslint-disable-line react/prop-types
    } = this.props;
    const { createQuestionnaireSectionNote } = this.context;

    const { logEvent } = EventTracking;

    logEvent('Saved a new Note');

    const requestBody = {
      type: 'QuestionnaireSectionNote',
      attributes: {
        householdID: householdId.toString(),
        content,
        weight: maxWeightFunc() + 1.0,
      },
    };
    createQuestionnaireSectionNote(householdId, sectionId, type, requestBody)
      .then(onDataUpdate)
      .then(this.onSaveFinish);
  }

  renderModalFooter() {
    const { onClose } = this.props;
    return (
      <div>
        <Button
          className="save"
          color="primary"
          variant="contained"
          disableElevation
          onClick={() => this.handleSave()}
        >
          Save
        </Button>
        <Button className="exit" onClick={onClose}>
          Close
        </Button>
      </div>
    );
  }

  render() {
    const { type, ...rest } = this.props;
    const { content } = this.state;
    const types = formTypesMap();
    const placeholder = types[type].header;
    return (
      <HeaderFooterModal
        {...rest}
        headerText={types[type].header}
        footer={this.renderModalFooter()}
        className="add-note-modal"
        onCtrlEnter={this.onCtrlEnter}
      >
        <Input
          placeholder={placeholder}
          name="section-note"
          label={placeholder}
          maxLength={1000}
          onChange={this.onChange}
          onKeyDown={this.onKeyDown}
          value={content}
        />
      </HeaderFooterModal>
    );
  }
}

AddNoteModal.contextType = SwaggerlessContext;

AddNoteModal.propTypes = {
  type: PropTypes.string.isRequired,
  footnotes: PropTypes.array,
  strategies: PropTypes.array,
  recommendations: PropTypes.array,
  maxWeightFunc: PropTypes.func.isRequired,
  onDataUpdate: PropTypes.func,
  isOpen: PropTypes.bool.isRequired,
  onClose: PropTypes.func.isRequired,
  content: PropTypes.string,
};

AddNoteModal.defaultProps = {
  footnotes: [],
  strategies: [],
  recommendations: [],
  onDataUpdate: noop,
  content: '',
};

const eventTrackingProperties = {
  nodeName: 'Add Note Modal',
};
export default withEventTrackingLogEvent(eventTrackingProperties, withHousehold(AddNoteModal));
